
import Vue from "vue"
import { Component, Prop } from "vue-property-decorator"

/* --- Types --- */
import { AuditTrailEntry } from "@/types/fieldReassignmentAudit"

@Component({})
export default class FieldReassignmentAuditTrailItem extends Vue {
	@Prop({ type: Object, required: true }) value!: AuditTrailEntry
}
